import FormSubmitActions from '@/utils/actions/form_submit_actions'
import { deepCloneObject } from '@/utils/misc'
import { SMAGableExtensions } from '@/xstore/utils/smagable'
import Utils from '@/utils/misc'
const deepEqual = require('deep-equal')



export default ({useExtension}) => {
    {
        const state = {
            submission_id: undefined,
            initial_empty_submission: undefined,
            submission_metrics_created: false,
            submission_metrics_started: false
        }
        useExtension(SMAGableExtensions.SMGable, {state})
    }

    return {
        actions: {
            resetSubmissionMetrics: ({ commit }) => {
                console.log('🔄 [SUBMISSION METRICS DEBUG] Resetting submission metrics')
                
                // Generate new UUID immediately when resetting
                const newSubmissionId = Utils.generateUUID()
                console.log('🆔 [SUBMISSION METRICS DEBUG] Generated fresh submission ID:', newSubmissionId)
                
                commit('SET_SUBMISSION_ID', newSubmissionId)
                commit('SET_INITIAL_EMPTY_SUBMISSION', undefined)
                commit('SET_SUBMISSION_METRICS_CREATED', false)
                commit('SET_SUBMISSION_METRICS_STARTED', false)
            },
            formSubmitOpened: async ({commit, getters, dispatch, parentDispatch, parentGetters}) => {
                commit('SET_INITIAL_EMPTY_SUBMISSION', deepCloneObject(parentGetters['submission/getFormSubmission']))
                parentDispatch('registerBeforeSubmitHook', {
                    hookID: 'submissionMetricsBeforeSubmit',
                    hook: () => dispatch('waitForSubmissionID')
                })

                // Create submission metrics immediately if we have a submission ID
                if (getters.getSubmissionId && !getters.getSubmissionMetricsCreated) {
                    console.log('🆕 [SUBMISSION METRICS DEBUG] Creating submission metrics immediately:', getters.getSubmissionId)
                    commit('SET_SUBMISSION_METRICS_CREATED')
                    
                    try {
                        await FormSubmitActions.sendSubmissionMetrics({
                            id: getters.getSubmissionId,
                            formID: parentGetters.getFormData.id,
                            started: false
                        })
                        console.log('✅ [SUBMISSION METRICS DEBUG] Submission metrics created successfully')
                    } catch (error) {
                        console.error('❌ [SUBMISSION METRICS DEBUG] Error creating submission metrics:', error)
                    }
                }
                
                // Fallback: still set the timeout for edge cases
                setTimeout(async () => {
                    if (!getters.getSubmissionMetricsCreated) {
                        console.log('⚠️ [SUBMISSION METRICS DEBUG] Fallback: Creating submission metrics after timeout')
                        commit('SET_SUBMISSION_METRICS_CREATED')
                        
                        // Use existing ID or generate new one if somehow missing
                        const submissionId = getters.getSubmissionId || Utils.generateUUID()
                        if (!getters.getSubmissionId) {
                            console.log('🆔 [SUBMISSION METRICS DEBUG] Generated fallback submission ID:', submissionId)
                            commit('SET_SUBMISSION_ID', submissionId)
                        }
                        
                        const {data: {id: responseSubmissionID}} = await FormSubmitActions.sendSubmissionMetrics({
                            id: submissionId,
                            formID: parentGetters.getFormData.id,
                            started: false
                        })
                        console.log('🆔 [SUBMISSION METRICS DEBUG] Backend confirmed submission ID:', responseSubmissionID)
                    }
                }, 4000)
            },
            waitForSubmissionID: async ({getters}) => {
                while (!getters.getSubmissionId)
                    await new Promise(resolve => setTimeout(resolve, 200))
            },
            formSubmissionChanged: async ({commit, getters, dispatch, parentGetters}) => {
                if (getters.getInitialEmptySubmission && !getters.getSubmissionMetricsStarted && !deepEqual(getters.getInitialEmptySubmission, parentGetters['submission/getFormSubmission'])) {
                    if (getters.getSubmissionMetricsCreated)
                        await dispatch('waitForSubmissionID')
                    else
                        commit('SET_SUBMISSION_METRICS_CREATED')
                    commit('SET_SUBMISSION_METRICS_STARTED')

                    const {data: {id: submissionID}} = await FormSubmitActions.sendSubmissionMetrics({
                        id: getters.getSubmissionId,
                        formID: parentGetters.getFormData.id,
                        started: true
                    })
                    if (!getters.getSubmissionId)
                        commit('SET_SUBMISSION_ID', submissionID)
                }
            },
            resetAfterSubmit: ({commit}) => {
                commit('SET_SUBMISSION_ID', undefined)
                commit('SET_INITIAL_EMPTY_SUBMISSION', undefined)
                commit('SET_SUBMISSION_METRICS_CREATED', false)
                commit('SET_SUBMISSION_METRICS_STARTED', false)
            }
        },
        getters: {
            getSubmissionId: ({ state }) => state.submission_id,
            getInitialEmptySubmission: ({ state }) => state.initial_empty_submission,
            getSubmissionMetricsCreated: ({ state }) => state.submission_metrics_created,
            getSubmissionMetricsStarted: ({ state }) => state.submission_metrics_started
        }
    }
}